var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mi_wrapper"},_vm._l((3),function(n,i){return _c('div',{key:i,staticClass:"mi_menu"})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }